module.exports = __webpack_public_path__ + "static/breathe-web.bd77278a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/breathe-web.jpg
// module id = 452
// module chunks = 118792369664667